module.exports = __webpack_public_path__ + "img/menu_invest_banner.ea2d02d7.png";